import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";
import { getDatosRegimenFiscal } from "./datosfiscales.act";

const mapState = (state) => {
	return {
        "tid": state.global.tid,
        "clienteUnico": state.global.clienteUnico,
		"loading": state.global.loading,
        "savedDatosFiscales":state.global.savedDatosFiscales
    };
};

const mapDispatch = (dispatch) => {
	return {
		alerta: (sTitulo, sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": sTitulo, "mensaje" : sMensaje });
		},
        changeSavedDatosFiscales(saved){
            dispatch({ type: 'DATOS_FISCALES', saved:saved});
        },
	};
};

class DatosFiscales extends React.Component {

	state = {
        hasDatosFiscales:false,
        datosFiscales:{
            rfc:"",
            cp:"",
            calle:"",
            numExt:"",
            nombreVialidad:"",
            tipoVialidad:"",
            numInt:"",
            colonia:"",
            municipio:"",
            estado:"",
            razonSocial:"",
            regimenFiscalSat:"",
            localidad:"",
        },
        estatusRegimen : 0
	}
    
    componentDidMount(){
        getDatosRegimenFiscal(this.props.clienteUnico,this.props.tid).then((res)=>{
            console.log(res);
            if(res.status == 200){
                this.setState({hasDatosFiscales:true,datosFiscales:res.data});
            }
            this.setState({estatusRegimen:res.status });
            console.log(this.state.estatusRegimen);
		}).catch((err)=>{
            this.setState({hasDatosFiscales:false});
			console.log("NO HAY DATOS GUARDADOS:"+ err);
		});
        if(this.props.savedDatosFiscales){
            this.props.alerta("DATOS GUARDADOS", "Tus datos han sido guardados con éxito." );
            this.props.changeSavedDatosFiscales(false);
        }
    }
	edit = () => {
        console.log("REEDIRECCION AL FORMULARIO");
        goTo("mi-perfil/regimen-fiscal");
	}

	render() {
        const {razonSocial,rfc,cp,calle,numExt,numInt,colonia,municipio,
            estado,regimenFiscalSat} = this.state.datosFiscales;
            if(this.state.estatusRegimen === 204) {
                return '';
            }
		return( 
            <div className="col-xs-12" id="datos-fiscales-miperfil">
                <div className="card perfil-card datosfisc-card">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-xs-12">
                                <i><img src={require("../img/documentos-icono.svg")} /></i><b>Datos fiscales</b>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {!this.state.hasDatosFiscales ?
                        <div className="col-xs-12 title-datos-fiscales">
                            <p><b>No has llenado tu perfil fiscal</b></p>
                            <p>Captura tus datos fiscales, será importante tenerlos actualizados si deseas facturar alguna de tus Pólizas.</p>
                            <div className="center card-actions-btn new-plus-button">
                                {
                                    <a id="dp_edit" onClick={this.edit} className="orange-btn">+</a>
                                }
                            </div>
                            <p> Agregar mi perfil fiscal </p> 
                        </div>
                        :
                        <div className="datos-fiscales-form">
                            <div className="clearfix">
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>Nombre o razón social</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{razonSocial.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>RFC</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{rfc.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>Régimen fiscal</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{regimenFiscalSat.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <hr className="data-separator" />
                            <div className="clearfix">
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>Código postal</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{cp.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>Calle</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{calle.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>No. exterior</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{numExt.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>No. interior</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{numInt.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>Colonia</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{colonia.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>Municipio</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{municipio.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6 mt-25">
                                    <div className="input-wrap">
                                        <label>Entidad federativa</label>
                                        <span className="blue-text datFisSpan">
                                            <p><b>{estado.toUpperCase()}</b></p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        )
	}
}
export default connect(mapState, mapDispatch)(DatosFiscales);



// WEBPACK FOOTER //
// ./src/miPerfil/datosfiscales.cmpt.js